import { render } from "./DetalheRecolhas.vue?vue&type=template&id=340668b7"
import script from "./DetalheRecolhas.vue?vue&type=script&lang=js"
export * from "./DetalheRecolhas.vue?vue&type=script&lang=js"
script.render = render

export default script